<template>
  <WidgetScrollCard header="Flex Row Dates" icon="calendar" :height>
    <template #badges>
      <Badge class="rounded-full" size="small" severity="danger" :value="todaysFlexRows.currentFlexRows.length"></Badge>
      <Badge class="rounded-full" size="small" severity="warning" :value="todaysFlexRows.upcomingFlexRows.length"></Badge>
    </template>
    <template #content>
      <div v-if="allFlexRows.length !== 0" class="flex flex-col gap-3">
        <div v-for="(flexRow, index) in allFlexRows">
          <Card pt:body="p-2">
            <template #content>
              <div class="flex flex-row gap-5 my-2">
                <div class="flex flex-col w-full">
                  <div class="flex flex-row gap items-center">
                    <i class="text-sm! my-auto pi pi-clock" :class="flexRow.passed ? 'text-danger-500' : 'text-warning-500'"></i>
                    <p class="text-sm font-bold ml-1" :class="flexRow.passed ? 'text-danger-500' : 'text-warning-500'">
                      {{ flexRow.date != null ? format(flexRow.date, "MM/dd/yyyy") : "" }}
                    </p>
                  </div>
                  <div class="w-fit text-sm">
                    {{ getProjectName(flexRow.projectId) }}
                  </div>
                  <h1 class="font-bold text-lg -my-1">{{ flexRow.label }}</h1>
                </div>
              </div>
            </template>
          </Card>
        </div>
      </div>
      <div v-else class="h-full flex">
        <p class="text-center font-bold w-full mt-28">---No Flex Row Dates to Show---</p>
      </div>
    </template>
  </WidgetScrollCard>
</template>

<script setup lang="ts">
import type { DashboardFlexRow, TodaysFlexRows } from "@/types/FlexRows";
import type { ProjectSummary } from "@/types/Projects";
import { format } from "date-fns";

const todaysFlexRows = defineModel<TodaysFlexRows>("todaysFlexRows", { required: true });
const allFlexRows = computed<DashboardFlexRow[]>(() => {
  return todaysFlexRows.value.currentFlexRows.concat(todaysFlexRows.value.upcomingFlexRows);
});

interface Props {
  projects: ProjectSummary[];
  passed: boolean;
  height: string;
}
const props = defineProps<Props>();

const getProjectName = (projectId: string): string => {
  const project = props.projects.find((project: ProjectSummary) => project.projectId === projectId);
  return project != null ? project.projectName : "";
};
</script>
